import dayjs from "dayjs";

export const formattedDateTime = (date: string) => {
  if (!date) return "-";

  return dayjs(date).format("DD/MM/YYYY HH:mm:ss");
};

export const formattedDate = (date: Date) => {
  if (!date) return "-";

  return dayjs(date).format("DD/MM/YYYY");
};

export const getCurrentQuarter = (): number => {
  const currentMonth = dayjs().month() + 1;
  return Math.ceil(currentMonth / 3);
};

export const getUpcomingQuarter = (): number => {
  const nextMonth = dayjs().add(1, "month");
  return Math.ceil((nextMonth.month() + 1) / 3);
};

export const getUpcomingQuarterYear = (): number => {
  return dayjs().add(1, "month").year();
};